// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://yahtgibtatgcvbniropq.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InlhaHRnaWJ0YXRnY3Zibmlyb3BxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDg0Mjg3MTAsImV4cCI6MjA2NDAwNDcxMH0.dRE9hVBRpepyvIcjB3Oyu7PCuc23mYa5OAUEearyIBY";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});